import ActionType from "../ActionType";

export const setEmissionSettings = (data: boolean) => (
  {
    type: ActionType.EMISSION_SETTINGS,
    data: data,
  }
);
